import { __commonJSMin as e } from "../../../../../../../_virtual/_rolldown/runtime.js";
//#region ../../node_modules/.pnpm/@intercom+intermoji@2.0.3/node_modules/@intercom/intermoji/lib/includes.js
var t = /* @__PURE__ */ e(((e, t) => {
	t.exports = function(e, t) {
		return e.indexOf(t) !== -1;
	};
}));
//#endregion
export default t();
export { t as require_includes };
